
import React, { useState, useEffect, useRef } from "react";
import { BASE_URL } from "../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, Row, Col, Container, Card, InputGroup } from 'react-bootstrap';
import '../../CommonCSS/SocietyCSS.css';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//import { Container, Row, Col, Card, Button, Table } from "react-bootstrap";

const PremiseTypeComp = () => {

  const [formData, setFormData] = useState({
    section_id: '',
    sec_hierarchy: '',
    section_desc: '',
    sec_prefix: '',
    school_name: '',
    allumini_type: '',
    allumini_name: '',

  });

  const [isEditable, setIsEditable] = useState(false);
  const [savedData, setSavedData] = useState([]);
  const premTypeRef = useRef(null);

  // Fetch data on mount
  useEffect(() => {
    fetchSavedData();
  }, []);

  const fetchSavedData = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/get_sections`);
      setSavedData(response.data);
    } catch (error) {
      console.error("Error fetching saved data:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleNew = () => {
    setIsEditable(true);
    setFormData({
      section_id: '',
      sec_hierarchy: '',
      section_desc: '',
      sec_prefix: '',
      school_name: '',
      allumini_type: '',
      allumini_name: '',

    });

  };

  const handleClear = () => {
    const isConfirmed = window.confirm("Sure you want to clear?");
    if (!isConfirmed) return;

    setIsEditable(false);
    setFormData({
      section_id: '',
      sec_hierarchy: '',
      section_desc: '',
      sec_prefix: '',
      school_name: '',
      allumini_type: '',
      allumini_name: '',
    });
  };

  const handleSave = async () => {

    if (!formData.sec_hierarchy) {
      toast.error("Please enter Section Hierarchy !");
      return;
    }

    if (!formData.section_desc) {
      toast.error("Please enter Section Description !");
      return;
    }

    if (!formData.sec_prefix) {
      toast.error("Please enter Prefix!");
      return;
    }

    if (!formData.school_name) {
      toast.error("Please enter School Name!");
      return;
    }

    if (!formData.allumini_type) {
      toast.error("Please enter Allumini!");
      return;
    }

    const isConfirmed = window.confirm("Do you want to save this record?");

    if (!isConfirmed) return;

    try {
      const response = await axios.post(`${BASE_URL}/api/save_section`, formData);

      if (response.data.message === '1') {
        toast.success("Section saved successfully!");
        fetchSavedData();
        setIsEditable(false);
        setFormData({
          section_id: '',
          sec_hierarchy: '',
          section_desc: '',
          sec_prefix: '',
          school_name: '',
          allumini_type: '',
          allumini_name: '',
        });
        //handleClear();
      } else {
        toast.error("Failed to save.");
      }
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  const handleRowClick = async (row) => {
    setFormData({
      section_id: row.section_id,
      sec_hierarchy: row.sec_hierarchy,
      section_desc: row.section_desc,
      sec_prefix: row.sec_prefix,
      school_name: row.school_name,
      allumini_type: row.allumini_type,
    });
    setIsEditable(true);
  };

  return (
    <Container fluid className="p-3">
      <Card className="mb-3 p-3">

        <Row className="mb-3">

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "150px" }}>
                Section Hierarchy
              </InputGroup.Text>

              <Form.Control
                type="number"
                style={{textAlign: 'right'}}
                name="sec_hierarchy"
                value={formData.sec_hierarchy}
                onChange={handleChange}
                disabled={!isEditable}
              />
            </InputGroup>
          </Col>

          <Col md={6}>
            <InputGroup>
              <InputGroup.Text style={{ width: "140px" }}>
                Section Name
              </InputGroup.Text>

              <Form.Control
                type="text"
                name="section_desc"
                value={formData.section_desc}
                onChange={handleChange}
                disabled={!isEditable}
              />
            </InputGroup>
          </Col>

          <Col md={2}>
            <InputGroup>
              <InputGroup.Text style={{ width: "70px" }}>
                Prefix
              </InputGroup.Text>

              <Form.Control
                type="text"
                name="sec_prefix"
                value={formData.sec_prefix}
                onChange={(e) =>
                  handleChange({
                    target: {
                      name: e.target.name,
                      value: e.target.value.toUpperCase()
                    }
                  })
                }
                disabled={!isEditable}
              />
            </InputGroup>
          </Col>

        </Row>

        <Row className="mb-3 justify-content-start">

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "150px" }}>
                School Name
              </InputGroup.Text>

              <Form.Control
                type="text"
                name="school_name"
                value={formData.school_name}
                onChange={handleChange}
                disabled={!isEditable}
              />
            </InputGroup>
          </Col>

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "140px" }}>
                Allumini
              </InputGroup.Text>

              <Form.Select
                name="allumini_type"
                value={formData.allumini_type}
                onChange={handleChange}
                disabled={!isEditable}
              >
                <option value="">-- Select Allumini --</option>
                <option value="S">School</option>
                <option value="JR">Junior College</option>
                <option value="DC">Degree College</option>
              </Form.Select>
            </InputGroup>
          </Col>

          <Col md={4}>

            <button className="btn btn-primary me-2"style={{ width: "135px" }}
            disabled={isEditable}onClick={handleNew}>New</button>

            <button className="btn btn-secondary me-2"style={{ width: "135px" }}
              onClick={handleClear}>Clear</button>

            <button className="btn btn-success"style={{ width: "135px" }} onClick={handleSave}
              disabled={!isEditable}>Save</button>
          </Col>
        </Row>
      </Card>

      <Card style={{ marginTop: '10px', padding: '15px' }}>
        <h5 className="mb-3">Available Sections</h5>
        <div className="table-wrapper">
          <table style={{ maxHeight: '35px' }} striped bordered hover className="responsive-table scty-custom-table">
            {/* size="sm"  */}
            <thead>
              <tr>
                <th style={{ width: '5%', textAlign: 'center' }}>#</th>
                <th style={{ width: '15%', textAlign: 'left' }}>Hierarchy</th>
                <th style={{ width: '40%', textAlign: 'left' }}>Section Description</th>
                <th style={{ width: '10%', textAlign: 'center' }}>Prefix</th>
                <th style={{ width: '40%', textAlign: 'left' }}>School name</th>
                <th style={{ width: '40%', textAlign: 'left' }}>Allumini</th>
              </tr>
            </thead>
            <tbody>
              {savedData.length > 0 ? (
                savedData.map((item, index) => (
                  <tr key={item.section_id} onClick={() =>
                    handleRowClick(item)} style={{ cursor: 'pointer' }}>
                    <td style={{ textAlign: 'center' }}>{index + 1}</td>
                    <td style={{ textAlign: 'center' }}>{item.sec_hierarchy}</td>
                    <td style={{ textAlign: 'left' }}>{item.section_desc}</td>
                    <td style={{ textAlign: 'center' }}>{item.sec_prefix}</td>
                    <td style={{ textAlign: 'left' }}>{item.school_name}</td>
                   <td style={{ textAlign: 'left' }}>{item.allumini_name}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">No records found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div >
      </Card>
    </Container>
  );
};

export default PremiseTypeComp;
